import {m} from '@codeurs/front'
import {ClassName} from 'util/style'

export const FacebookIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
    <path d="M45,0H3A3,3,0,0,0,0,3V45a3,3,0,0,0,3,3H25.64V29.44H19.41V22.17h6.23V16.82c0-6.2,3.79-9.57,9.32-9.57a54.31,54.31,0,0,1,5.59.28V14H36.73c-3,0-3.59,1.43-3.59,3.52v4.63h7.2l-.94,7.27H33.14V48H45a3,3,0,0,0,3-3V3A3,3,0,0,0,45,0Z" />
  </svg>
)

export const InstagramIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
    <path d="M34.74,15.87a4.57,4.57,0,0,0-2.61-2.61,7.58,7.58,0,0,0-2.56-.48c-1.45-.06-1.89-.08-5.57-.08s-4.12,0-5.57.08a7.58,7.58,0,0,0-2.56.48,4.57,4.57,0,0,0-2.61,2.61,7.58,7.58,0,0,0-.48,2.56c-.06,1.45-.08,1.89-.08,5.57s0,4.12.08,5.57a7.58,7.58,0,0,0,.48,2.56,4.57,4.57,0,0,0,2.61,2.61,7.58,7.58,0,0,0,2.56.48c1.45.06,1.89.08,5.57.08s4.12,0,5.57-.08a7.59,7.59,0,0,0,2.57-.48,4.58,4.58,0,0,0,2.6-2.61,7.46,7.46,0,0,0,.48-2.56c.06-1.45.08-1.89.08-5.57s0-4.12-.08-5.57A7.58,7.58,0,0,0,34.74,15.87ZM25.39,31A7.08,7.08,0,1,1,31,25.39,7.1,7.1,0,0,1,25.39,31Zm6-12.65A1.66,1.66,0,1,1,33,16.64,1.66,1.66,0,0,1,31.36,18.3Z" />
    <path d="M28.54,23.27a4.6,4.6,0,1,1-3.81-3.81A4.61,4.61,0,0,1,28.54,23.27Z" />
    <path d="M45,0H3A3,3,0,0,0,0,3V45a3,3,0,0,0,3,3H45a3,3,0,0,0,3-3V3A3,3,0,0,0,45,0ZM37.7,29.68A10.25,10.25,0,0,1,37.06,33a7.07,7.07,0,0,1-4,4,10.19,10.19,0,0,1-3.35.64c-1.47.07-1.94.08-5.68.08s-4.21,0-5.68-.08A10.25,10.25,0,0,1,15,37.06a7.06,7.06,0,0,1-4-4,10.25,10.25,0,0,1-.64-3.35c-.07-1.47-.08-1.94-.08-5.68s0-4.21.08-5.68A10.25,10.25,0,0,1,10.94,15a7.06,7.06,0,0,1,4-4,10.25,10.25,0,0,1,3.35-.64c1.47-.07,1.94-.08,5.68-.08s4.21,0,5.68.08a10.25,10.25,0,0,1,3.35.64,7.06,7.06,0,0,1,4,4,10.25,10.25,0,0,1,.64,3.35c.07,1.47.08,1.94.08,5.68S37.77,28.21,37.7,29.68Z" />
  </svg>
)

export const LinkedinIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
    <path d="M45,0H3A3,3,0,0,0,0,3V45a3,3,0,0,0,3,3H45a3,3,0,0,0,3-3V3A3,3,0,0,0,45,0ZM17,36.28H11.18V18.7H17Zm-2.93-20h0a3,3,0,1,1,.07-6.07,3,3,0,1,1,0,6.07Zm24,20H32.26V26.87c0-2.36-.85-4-3-4a3.19,3.19,0,0,0-3,2.13,3.94,3.94,0,0,0-.19,1.43v9.82H20.26s.08-15.93,0-17.58h5.85v2.49a5.78,5.78,0,0,1,5.26-2.91c3.85,0,6.73,2.52,6.73,7.92Z" />
  </svg>
)

export const RssIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
    <path d="M45,0H3A3,3,0,0,0,0,3V45a3,3,0,0,0,3,3H45a3,3,0,0,0,3-3V3A3,3,0,0,0,45,0ZM14.88,39.54A5,5,0,1,1,19,35.44,5,5,0,0,1,14.88,39.54Zm16-3.24a3.07,3.07,0,0,1-.9,2.17,3.11,3.11,0,0,1-2.18.9,3.08,3.08,0,0,1-3.08-3.07l0-1.72a10,10,0,0,0-10-10H12.43a3.18,3.18,0,0,1-3.16-2.49,3.11,3.11,0,0,1,3-3.73h2.41A16.16,16.16,0,0,1,30.87,33.8a1,1,0,0,1,0,.16v.31a3,3,0,0,1,0,.31ZM41.2,34.74v1.48a2.84,2.84,0,0,1-5.67,0V34.14A21.28,21.28,0,0,0,14.65,13.49H12.14a2.92,2.92,0,0,1-3-2.68,2.82,2.82,0,0,1,2.81-3H14.6l.19,0A27,27,0,0,1,41.14,33a2.81,2.81,0,0,1,.06.59Z" />
  </svg>
)

export const TiktokIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
    <g>
      <path
        d="M45,0H3A3,3,0,0,0,0,3V45a3,3,0,0,0,3,3H45a3,3,0,0,0,3-3V3A3,3,0,0,0,45,0ZM19.52,15.31a8.8,8.8,0,0,1,1.36.1v5.46a4.64,4.64,0,0,0-2.28-.12A4.52,4.52,0,1,0,24,25.2V3.84h5.38v.74c0,.2.08.41.08.61a7.44,7.44,0,0,0,3.42,5,7.35,7.35,0,0,0,4,1.13v5.35a12.75,12.75,0,0,1-7.45-2.38V24.84a10.13,10.13,0,0,1-9.72,10.24,9.89,9.89,0,1,1-.16-19.77ZM14,39.12H12.72v5H11.16V39.06H9.6V37.73l4.84,0Zm2.23,5H14.71V39.78h1.52Zm-.76-4.88a.76.76,0,1,1,.76-.76A.76.76,0,0,1,15.47,39.24Zm4.89,4.92L18.87,42l-.47.43v1.65H16.88V37.73l1.52,0v3l1.52-1.51h1.86l-1.92,1.87L22,44.16Zm5.11-5v5H23.91V39.06H22.35V37.73l4.82,0-.43,1.36Zm4.27,5a1.71,1.71,0,0,1-.32,0,2.63,2.63,0,1,1,.32-5.25h.32a2.63,2.63,0,1,1-.32,5.25Zm7,0L35.28,42l-.47.43v1.65H33.29V37.73l1.52,0v3l1.53-1.51h1.84l-1.92,1.87,2.14,3.09Z"
        fill-rule="evenodd"
      />
      <path
        d="M29.71,40.23a1.29,1.29,0,0,0,0,2.58h0a1.29,1.29,0,1,0,0-2.58Z"
        fill-rule="evenodd"
      />
    </g>
  </svg>
)

export const TwitterIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
    <path d="M48,0H0v48h48V0ZM38.69,9l-11.12,12.71,13.08,17.29h-10.24l-8.01-10.49-9.18,10.49h-5.09l11.89-13.6L7.47,9h10.5l7.25,9.59,8.38-9.59h5.09ZM34.64,35.96L16.44,11.88h-3.03l18.41,24.08h2.83Z" />
  </svg>
)

export const YoutubeIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
    <path d="M21,28.5,28.82,24,21,19.5Z" />
    <path d="M45,0H3A3,3,0,0,0,0,3V45a3,3,0,0,0,3,3H45a3,3,0,0,0,3-3V3A3,3,0,0,0,45,0ZM39,24a39.52,39.52,0,0,1-.62,7.22,3.76,3.76,0,0,1-2.64,2.64C33.39,34.5,24,34.5,24,34.5s-9.36,0-11.74-.64a3.78,3.78,0,0,1-2.64-2.65A39.25,39.25,0,0,1,9,24a39.37,39.37,0,0,1,.62-7.21,3.82,3.82,0,0,1,2.64-2.67C14.61,13.5,24,13.5,24,13.5s9.39,0,11.74.64a3.78,3.78,0,0,1,2.64,2.65A37.75,37.75,0,0,1,39,24Z" />
  </svg>
)

export const ArrowLinkIcon: React.FC<{className?: ClassName}> = ({
  className,
  ...props
}) => {
  return (
    <svg
      version="1.1"
      x="0px"
      y="0px"
      width="451.846px"
      height="451.847px"
      viewBox="0 0 451.846 451.847"
      className={className && className.toString()}
      {...props}
    >
      <g>
        <path
          d="M345.441,248.292L151.154,442.573c-12.359,12.365-32.397,12.365-44.75,0c-12.354-12.354-12.354-32.391,0-44.744
		L278.318,225.92L106.409,54.017c-12.354-12.359-12.354-32.394,0-44.748c12.354-12.359,32.391-12.359,44.75,0l194.287,194.284
		c6.177,6.18,9.262,14.271,9.262,22.366C354.708,234.018,351.617,242.115,345.441,248.292z"
        />
      </g>
    </svg>
  )
}

export const ExternalLinkIcon = ({className = null}) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 511.999 511.999"
    className={className || ''}
  >
    <g>
      <g>
        <path
          d="M436.921,75.079C389.413,27.571,326.51,1.066,259.464,0.18C258.296,0.074,257.137,0,255.999,0s-2.297,0.074-3.465,0.18
				C185.488,1.065,122.585,27.57,75.077,75.078C26.752,123.405,0.138,187.657,0.138,255.999s26.614,132.595,74.94,180.921
				c47.508,47.508,110.41,74.013,177.457,74.898c1.168,0.107,2.327,0.18,3.464,0.18c1.138,0,2.297-0.074,3.465-0.18
				c67.047-0.885,129.95-27.39,177.457-74.898c48.325-48.325,74.939-112.577,74.939-180.921
				C511.861,187.657,485.247,123.405,436.921,75.079z M96.586,96.587c27.181-27.181,60.086-46.552,95.992-57.018
				c-8.093,9.317-15.96,20.033-23.282,31.908c-9.339,15.146-17.425,31.562-24.196,48.919H75.865
				C82.165,112.063,89.071,104.102,96.586,96.587z M56.486,150.813h78.373c-8.15,28.522-12.97,58.908-14.161,89.978H31.071
				C33.176,208.987,41.865,178.465,56.486,150.813z M56.487,361.186c-14.623-27.652-23.312-58.174-25.417-89.978h89.627
				c1.191,31.071,6.011,61.457,14.161,89.978H56.487z M96.587,415.412c-7.517-7.515-14.423-15.475-20.722-23.809h69.236
				c6.771,17.357,14.856,33.773,24.196,48.919c7.322,11.875,15.189,22.591,23.282,31.908
				C156.674,461.964,123.769,442.593,96.587,415.412z M240.79,475.322c-12.671-8.29-29.685-24.946-45.605-50.764
				c-6.385-10.354-12.124-21.382-17.197-32.954h62.801V475.322z M240.79,361.186h-74.195c-8.888-28.182-14.163-58.651-15.459-89.978
				h89.654V361.186z M240.79,240.791h-89.654c1.295-31.327,6.57-61.797,15.459-89.978h74.195V240.791z M240.79,120.395h-62.801
				c5.073-11.572,10.812-22.6,17.197-32.954c15.919-25.818,32.934-42.475,45.605-50.764V120.395z M455.512,150.813
				c14.623,27.653,23.311,58.174,25.416,89.978H391.3c-1.191-31.071-6.011-61.457-14.161-89.978H455.512z M415.413,96.587
				c7.515,7.515,14.421,15.476,20.721,23.809h-69.235c-6.771-17.357-14.856-33.773-24.196-48.919
				c-7.322-11.875-15.188-22.591-23.282-31.908C355.326,50.035,388.231,69.406,415.413,96.587z M271.208,36.677
				c12.671,8.29,29.685,24.946,45.605,50.764c6.385,10.354,12.124,21.382,17.197,32.954h-62.801V36.677z M271.208,150.813h74.195
				c8.889,28.182,14.164,58.653,15.459,89.978h-89.654V150.813z M360.861,271.208c-1.295,31.327-6.57,61.797-15.459,89.978h-74.195
				v-89.978H360.861z M271.208,475.322v-83.718h62.801c-5.073,11.572-10.812,22.6-17.197,32.954
				C300.893,450.377,283.879,467.032,271.208,475.322z M415.413,415.413c-27.182,27.181-60.086,46.551-95.992,57.018
				c8.093-9.317,15.96-20.033,23.282-31.908c9.339-15.146,17.425-31.562,24.196-48.919h69.235
				C429.835,399.937,422.928,407.898,415.413,415.413z M455.512,361.186h-78.373c8.15-28.521,12.971-58.907,14.161-89.978h89.627
				C478.822,303.012,470.133,333.534,455.512,361.186z"
        />
      </g>
    </g>
  </svg>
)

export const FileIcon = ({className = null}) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 489.104 489.104"
    className={className || ''}
  >
    <g>
      <path
        d="M411.55,100.9l-94.7-94.7c-4.2-4.2-9.4-6.2-14.6-6.2H92.15c-11.4,0-20.8,9.4-20.8,20.8v330.8c0,11.4,9.4,20.8,20.8,20.8
			h132.1V421l-16.6-15.2c-8.3-7.3-21.8-7.3-29.1,1s-7.3,21.8,1,29.1l52,47.9c3.1,3.1,14.6,10.2,29.1,0l52-47.9
			c8.3-8.3,8.3-20.8,1-29.1c-8.3-8.3-20.8-8.3-29.1-1l-18.7,17.2v-50.5h132.1c11.4,0,19.8-9.4,19.8-19.8V115.5
			C417.85,110.3,415.75,105.1,411.55,100.9z M324.15,70.4l39.3,38.9h-39.3V70.4z M265.95,331.9v-130c0-11.4-9.4-20.8-20.8-20.8
			c-11.4,0-20.8,9.4-20.8,20.8v130h-111.3V41.6h169.6v86.3c0,11.4,9.4,20.8,20.8,20.8h74.9v183.1h-112.4V331.9z"
      />
    </g>
  </svg>
)

export const InternalLinkIcon = ({className = null}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 23.95 24"
    className={className || ''}
  >
    <g>
      <path d="M1.35,24a3.73,3.73,0,0,1-.61-.26A1.56,1.56,0,0,1,0,22.35v-19A1.6,1.6,0,0,1,1.76,1.61c3.57,0,7.15,0,10.72,0h.27v1.6H2.51a.8.8,0,0,0-.91.9V21.45c0,.65.29.95.94.95H19.86a.8.8,0,0,0,.89-.9V11.22h1.6V22.07A1.66,1.66,0,0,1,21,24Z" />
      <path d="M9.72,13.28A1.07,1.07,0,0,1,9.88,13L22.49.34a.91.91,0,0,1,.7-.34.75.75,0,0,1,.67.44.73.73,0,0,1-.07.8,1.58,1.58,0,0,1-.22.23Q17.31,7.76,11.07,14a1.89,1.89,0,0,1-.31.25l.05.09h.29l5.69,0a.75.75,0,0,1,.72.41.81.81,0,0,1-.05.86.74.74,0,0,1-.66.33L8.86,16A.77.77,0,0,1,8,15.18q0-4,0-7.92a.76.76,0,0,1,.79-.8.78.78,0,0,1,.82.82c0,1.86,0,3.72,0,5.57v.35Z" />
    </g>
  </svg>
)

export const ArrowIcon = ({className = null}) => (
  <svg width="13px" height="8px" className={className}>
    <path
      fill-rule="evenodd"
      d="M12.635,7.635 C12.161,8.119 11.391,8.119 10.916,7.635 L6.425,3.003 L2.040,7.528 C1.574,8.003 0.818,8.003 0.351,7.528 C-0.114,7.052 -0.114,6.282 0.351,5.806 L5.477,0.517 C5.477,0.516 5.479,0.516 5.479,0.515 C5.514,0.468 5.532,0.414 5.573,0.371 C6.048,-0.113 6.818,-0.113 7.293,0.371 L12.635,5.881 C13.111,6.366 13.111,7.150 12.635,7.635 Z"
    />
  </svg>
)
export const ArrowIconDropdown = ({className = null}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13.031"
    height="8"
    viewBox="0 0 13.031 8"
    className={className}
  >
    <path
      id="Rounded_Rectangle_4_copy_11"
      fill=" #383f50"
      data-name="Rounded Rectangle 4 copy 11"
      class="cls-1"
      d="M356.648,611.194l-5.125,5.289a1.178,1.178,0,0,1-1.688,0,1.235,1.235,0,0,1,0-1.722l5.125-5.289a1.178,1.178,0,0,1,1.688,0A1.235,1.235,0,0,1,356.648,611.194Zm-5.221,3.681-5.343-5.51a1.2,1.2,0,0,0-1.719,0,1.254,1.254,0,0,0,0,1.753l5.342,5.511a1.2,1.2,0,0,0,1.72,0A1.258,1.258,0,0,0,351.427,614.875Z"
      transform="translate(-344 -609)"
    />
  </svg>
)

export const ShareIcon = ({className = null}) => (
  <svg width="18px" height="19px" className={className}>
    <path d="M14.594,12.209 C13.496,12.209 12.516,12.730 11.890,13.534 L6.643,10.619 C6.766,10.268 6.833,9.889 6.833,9.498 C6.833,9.104 6.766,8.729 6.639,8.374 L11.882,5.463 C12.504,6.272 13.488,6.796 14.590,6.796 C16.470,6.796 18.004,5.273 18.004,3.400 C18.004,1.526 16.474,0.003 14.590,0.003 C12.706,0.003 11.176,1.526 11.176,3.400 C11.176,3.795 11.243,4.173 11.370,4.524 L6.132,7.435 C5.509,6.623 4.526,6.102 3.423,6.102 C1.543,6.102 0.009,7.625 0.009,9.498 C0.009,11.372 1.543,12.895 3.427,12.895 C4.530,12.895 5.513,12.371 6.139,11.558 L11.382,14.473 C11.255,14.828 11.184,15.211 11.184,15.605 C11.184,17.475 12.714,19.002 14.598,19.002 C16.482,19.002 18.012,17.479 18.012,15.605 C18.012,13.731 16.478,12.209 14.594,12.209 ZM14.594,1.072 C15.887,1.072 16.938,2.118 16.938,3.404 C16.938,4.690 15.887,5.735 14.594,5.735 C13.301,5.735 12.250,4.690 12.250,3.404 C12.250,2.118 13.305,1.072 14.594,1.072 ZM3.427,11.831 C2.134,11.831 1.083,10.785 1.083,9.498 C1.083,8.212 2.134,7.167 3.427,7.167 C4.720,7.167 5.771,8.212 5.771,9.498 C5.771,10.785 4.716,11.831 3.427,11.831 ZM14.594,17.933 C13.301,17.933 12.250,16.888 12.250,15.601 C12.250,14.315 13.301,13.270 14.594,13.270 C15.887,13.270 16.938,14.315 16.938,15.601 C16.938,16.888 15.887,17.933 14.594,17.933 Z" />
  </svg>
)

export const SearchIcon = ({className = null}) => (
  <svg width="16px" height="16px" className={className}>
    <path
      fill-rule="evenodd"
      fill="rgb(20, 34, 63)"
      d="M15.737,14.484 L12.548,11.277 C13.625,10.040 14.215,8.483 14.215,6.864 C14.215,3.079 11.027,0.000 7.108,0.000 C3.189,0.000 0.001,3.079 0.001,6.864 C0.001,10.648 3.189,13.727 7.108,13.727 C8.579,13.727 9.981,13.299 11.180,12.485 L14.401,15.725 C14.578,15.902 14.815,16.000 15.069,16.000 C15.310,16.000 15.538,15.911 15.712,15.750 C16.080,15.408 16.092,14.840 15.737,14.484 ZM7.108,1.791 C10.005,1.791 12.361,4.066 12.361,6.864 C12.361,9.661 10.005,11.937 7.108,11.937 C4.212,11.937 1.855,9.661 1.855,6.864 C1.855,4.066 4.212,1.791 7.108,1.791 Z"
    />
  </svg>
)

export const ScribdIcon = () => (
  <svg
    id="a"
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 48 48"
  >
    <path d="M45,0H3C1.34,0,0,1.34,0,3V45c0,1.66,1.34,3,3,3H45c1.66,0,3-1.34,3-3V3c0-1.66-1.34-3-3-3ZM13.66,18.77v-.07c0-5.13,4.08-8.7,9.91-8.7,3.62-.06,7.14,1.15,9.95,3.43l.96,.76-2.99,4.27-2.21-1.46,1.59-2.29c-2.16-1.42-4.7-2.16-7.29-2.12-1.28-.02-2.55,.23-3.73,.74-.38,.19-.74,.41-1.08,.66-1.2,.87-1.81,1.9-1.81,3.11,0,.72,.3,1.08,.89,1.08,.27-.02,.54-.08,.8-.15,.33-.08,.67-.12,1-.13,.86,.02,1.68,.36,2.3,.96,.73,.68,1.13,1.64,1.08,2.64,.01,1.05-.39,2.06-1.12,2.8-.8,.81-1.92,1.24-3.06,1.18-1.44,.05-2.83-.57-3.75-1.68-.95-1.13-1.46-2.72-1.47-4.73v-.3Zm19.09,16.61c-1.83,1.57-4.14,2.47-6.55,2.55-.44,.06-.9,.06-1.37,.06-4.16,.02-8.19-1.51-11.3-4.28l-.91-.82,3.59-4.26,2.11,1.63-2,2.33c2.47,1.83,5.46,2.82,8.53,2.8,3.67,0,6.21-1.39,7.19-3.81,.06-.25,.08-.5,.08-.75,0-.72-.3-1.08-.89-1.08-.27,.02-.54,.08-.8,.15-.33,.08-.67,.12-1,.13-.87-.02-1.71-.37-2.33-.98-.73-.67-1.13-1.63-1.09-2.62-.02-1.05,.39-2.06,1.12-2.8,.8-.81,1.92-1.24,3.06-1.18,1.44-.05,2.83,.58,3.75,1.69,.95,1.13,1.42,2.7,1.42,4.71,0,2.77-.87,4.95-2.62,6.52Z" />
  </svg>
)

export const UserIcon = () => (
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 4C4 5.65625 5.34375 7 7 7C8.65625 7 10 5.65625 10 4C10 2.34375 8.65625 1 7 1C5.34375 1 4 2.34375 4 4ZM11 4C11 6.21875 9.21875 8 7 8C4.78125 8 3 6.21875 3 4C3 1.78125 4.78125 0 7 0C9.21875 0 11 1.78125 11 4ZM1 15V15.5C1 15.7812 0.78125 16 0.5 16C0.21875 16 0 15.7812 0 15.5V15C0 11.9688 2.46875 9.5 5.5 9.5H8.5C11.5312 9.5 14 11.9688 14 15V15.5C14 15.7812 13.7812 16 13.5 16C13.2188 16 13 15.7812 13 15.5V15C13 12.5312 11 10.5 8.5 10.5H5.5C3.03125 10.5 1 12.5312 1 15Z"
      fill="currentColor"
    />
  </svg>
)

export const EnvelopeIcon = () => (
  <svg
    width="16"
    height="12"
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 1.84375V1.75C0.03125 0.78125 0.84375 0 1.84375 0H14.1875C15.1562 0 15.9688 0.78125 16 1.75V10C16 11.0938 15.0938 12 14 12H2C0.90625 12 0 11.0938 0 10V1.84375ZM15 3.5L9.46875 7.53125C8.59375 8.1875 7.40625 8.1875 6.53125 7.53125L1 3.5V10C1 10.5625 1.4375 11 2 11H14C14.5625 11 15 10.5625 15 10V3.5ZM15 1.84375C15 1.375 14.625 1 14.1875 1H1.84375C1.375 1 1 1.375 1 1.84375C1 2.09375 1.125 2.34375 1.34375 2.5L7.125 6.71875C7.65625 7.125 8.375 7.125 8.875 6.71875L14.6562 2.5C14.875 2.34375 15 2.09375 15 1.8125V1.84375Z"
      fill="currentColor"
    />
  </svg>
)

export const BriefcaseIcon = () => (
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 1.5V3H10V1.5C10 1.21875 9.78125 1 9.5 1H6.5C6.21875 1 6 1.21875 6 1.5ZM5 3V1.5C5 0.6875 5.6875 0 6.5 0H9.5C10.3438 0 11 0.6875 11 1.5V3H14C15.0938 3 16 3.90625 16 5V13C16 14.0938 15.0938 15 14 15H2C0.90625 15 0 14.0938 0 13V5C0 3.90625 0.90625 3 2 3H5ZM10.5 4H2C1.4375 4 1 4.4375 1 5V8H15V5C15 4.4375 14.5625 4 14 4H10.5ZM15 9H10.5V10.5C10.5 11.0625 10.0625 11.5 9.5 11.5H6.5C5.9375 11.5 5.5 11.0625 5.5 10.5V9H1V13C1 13.5625 1.4375 14 2 14H14C14.5625 14 15 13.5625 15 13V9ZM6.5 9V10.5H9.5V9H6.5Z"
      fill="currentColor"
    />
  </svg>
)

export const CheckIcon = () => (
  <svg
    width="15"
    height="14"
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.6875 0.3125C14.125 0.65625 14.2188 1.28125 13.9062 1.71875L5.90625 12.7188C5.71875 12.9375 5.46875 13.0938 5.1875 13.125C4.875 13.1562 4.59375 13.0312 4.375 12.8438L0.375 8.84375C0 8.4375 0 7.8125 0.375 7.40625C0.78125 7.03125 1.40625 7.03125 1.8125 7.40625L4.96875 10.5938L12.2812 0.53125C12.625 0.09375 13.25 0 13.6875 0.3125Z"
      fill="white"
    />
  </svg>
)
